import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_CONFIG_ID = 'configId'

export const productionDashboardSearchParams = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string(),
  [SEARCH_PARAM_SITE_ID]: z.string(),
})
export type ProductionDashboardSearch = z.infer<
  typeof productionDashboardSearchParams
>

export const productionDashboardConfigSearchParams = z.object({
  ...productionDashboardSearchParams.shape,
  [SEARCH_PARAM_CONFIG_ID]: z.string(),
})
export type ProductionDashboardConfigSearch = z.infer<
  typeof productionDashboardConfigSearchParams
>

export const createProductionDashboardSearch = ({
  orgId,
  siteId,
}: ProductionDashboardSearch) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
})

export const createProductionDashboardConfigSearch = ({
  orgId,
  siteId,
  configId,
}: ProductionDashboardConfigSearch) => ({
  ...createProductionDashboardSearch({ orgId, siteId }),
  [SEARCH_PARAM_CONFIG_ID]: configId,
})
